var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/lib/Dropzone.tsx
import { useCallback } from "react";
import { styled } from "@mui/material/styles";
import { useDropzone } from "react-dropzone";
import { useFormContext } from "react-hook-form";
import { Divider } from "@availity/mui-divider";
import { CloudUploadIcon, PlusIcon } from "@availity/mui-icon";
import { Box, Stack } from "@availity/mui-layout";
import { Typography } from "@availity/mui-typography";

// src/lib/FilePickerBtn.tsx
import { Controller } from "react-hook-form";
import { Button } from "@availity/mui-button";
import { Input } from "@availity/mui-form-utils";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var FilePickerBtn = (_a) => {
  var _b = _a, {
    name,
    children,
    color,
    inputId,
    inputProps = {},
    maxSize,
    onChange,
    onClick
  } = _b, rest = __objRest(_b, [
    "name",
    "children",
    "color",
    "inputId",
    "inputProps",
    "maxSize",
    "onChange",
    "onClick"
  ]);
  const { accept, multiple, ref, style, type: inputType } = inputProps;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Controller,
      {
        name,
        defaultValue: [],
        render: ({ field }) => /* @__PURE__ */ jsx(
          Input,
          __spreadProps(__spreadValues({}, field), {
            onChange,
            value: [],
            inputRef: ref,
            type: inputType,
            sx: style,
            inputProps: {
              accept,
              size: maxSize != null ? maxSize : void 0,
              multiple
            },
            id: inputId
          })
        )
      }
    ),
    /* @__PURE__ */ jsx(Button, __spreadProps(__spreadValues({ color }, rest), { onClick, fullWidth: false, children }))
  ] });
};

// src/lib/Dropzone.tsx
import { Fragment as Fragment2, jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var outerBoxStyles = {
  backgroundColor: "background.secondary",
  border: "1px dotted",
  borderColor: "secondary.light",
  borderRadius: "4px",
  padding: "2rem",
  "&:hover": {
    backgroundColor: "background.primary",
    borderColor: "border.primary"
  }
};
var innerBoxStyles = {
  width: "100%",
  height: "100%"
};
var createCounter = () => {
  let id = 0;
  const increment = () => id += 1;
  return {
    id,
    increment
  };
};
var counter = createCounter();
var DropzoneContainer = styled(Box, { name: "AvDropzoneContainer", slot: "root" })({
  ".MuiDivider-root": {
    width: "196px",
    marginLeft: "auto",
    marginRight: "auto"
  }
});
var Dropzone = ({
  allowedFileTypes = [],
  disabled,
  enableDropArea = true,
  maxFiles,
  maxSize,
  multiple,
  name,
  onChange,
  onClick,
  onDrop,
  setFileRejections,
  setTotalSize,
  validator
}) => {
  const { getValues, setValue, watch } = useFormContext();
  const handleValidation = useCallback(
    (file) => {
      var _a2;
      const previous = (_a2 = watch(name)) != null ? _a2 : [];
      const errors = [];
      const isDuplicate = previous.some((prev) => prev.name === file.name);
      if (isDuplicate) {
        errors.push({
          code: "duplicate-name",
          message: "A file with this name already exists"
        });
      }
      const hasMaxFiles = maxFiles && previous.length >= maxFiles;
      if (hasMaxFiles) {
        errors.push({
          code: "too-many-files",
          message: `Too many files. You may only upload ${maxFiles} file(s).`
        });
      }
      if (validator) {
        const validatorErrors = validator(file);
        if (validatorErrors) {
          if (Array.isArray(validatorErrors)) {
            errors.push(...validatorErrors);
          } else {
            errors.push(validatorErrors);
          }
        }
      }
      return errors.length > 0 ? errors : null;
    },
    [maxFiles, validator]
  );
  const handleOnDrop = useCallback(
    (acceptedFiles, fileRejections, event) => {
      var _a2;
      let newSize = 0;
      for (const file of acceptedFiles) {
        newSize += file.size;
      }
      setTotalSize((prev) => prev + newSize);
      const previous = (_a2 = watch(name)) != null ? _a2 : [];
      setValue(name, previous.concat(acceptedFiles));
      if (fileRejections.length > 0) {
        const TOO_MANY_FILES_CODE = "too-many-files";
        let hasTooManyFiles = false;
        fileRejections = fileRejections.reduce(
          (acc, rejection) => {
            const isTooManyFiles = rejection.errors.some((error) => error.code === TOO_MANY_FILES_CODE);
            if (isTooManyFiles) {
              if (!hasTooManyFiles) {
                hasTooManyFiles = true;
                acc.push(__spreadProps(__spreadValues({}, rejection), {
                  id: counter.increment()
                }));
              }
            } else {
              acc.push(__spreadProps(__spreadValues({}, rejection), {
                id: counter.increment()
              }));
            }
            return acc;
          },
          []
        );
      }
      if (setFileRejections) setFileRejections(fileRejections);
      if (onDrop) onDrop(acceptedFiles, fileRejections, event);
    },
    [setFileRejections]
  );
  const accept = allowedFileTypes.join(",");
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: handleOnDrop,
    maxSize,
    maxFiles,
    disabled,
    multiple,
    accept,
    validator: handleValidation
  });
  const inputProps = getInputProps({
    multiple,
    accept,
    onChange
  });
  const _a = getRootProps(), { role, tabIndex } = _a, rootProps = __objRest(_a, ["role", "tabIndex"]);
  const handleOnChange = (event) => {
    if (inputProps.onChange) {
      inputProps.onChange(event);
    }
  };
  const handleOnClick = (event) => {
    if (!enableDropArea && rootProps.onClick) rootProps.onClick(event);
    if (onClick) onClick;
  };
  const getFieldValue = () => {
    const field = getValues();
    return field[name] || [];
  };
  const hasFiles = getFieldValue().length > 0;
  return enableDropArea ? /* @__PURE__ */ jsx2(DropzoneContainer, __spreadProps(__spreadValues({ sx: outerBoxStyles }, rootProps), { children: /* @__PURE__ */ jsx2(Box, { sx: innerBoxStyles, children: /* @__PURE__ */ jsx2(Stack, { spacing: 2, alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ jsxs2(Fragment2, { children: [
    /* @__PURE__ */ jsx2(CloudUploadIcon, { fontSize: "xlarge", color: "secondary" }),
    /* @__PURE__ */ jsx2(Typography, { variant: "subtitle2", fontWeight: "700", children: "Drag and Drop Files Here" }),
    /* @__PURE__ */ jsx2(Divider, { flexItem: true, children: /* @__PURE__ */ jsx2(Typography, { variant: "subtitle2", children: "OR" }) }),
    /* @__PURE__ */ jsx2(
      FilePickerBtn,
      {
        name,
        color: "primary",
        disabled,
        maxSize,
        onClick,
        inputProps,
        onChange: handleOnChange,
        children: "Browse Files"
      }
    )
  ] }) }) }) })) : /* @__PURE__ */ jsx2(
    FilePickerBtn,
    {
      name,
      color: "tertiary",
      disabled,
      maxSize,
      onClick: handleOnClick,
      inputProps,
      onChange: handleOnChange,
      startIcon: /* @__PURE__ */ jsx2(PlusIcon, {}),
      children: hasFiles ? "Add More Files" : "Add File(s)"
    }
  );
};

// src/lib/ErrorAlert.tsx
import { Alert, AlertTitle } from "@availity/mui-alert";
import { List, ListItem } from "@availity/mui-list";

// src/lib/util.ts
import {
  FileArchiveIcon,
  FileCodeIcon,
  FileCsvIcon,
  FileExcelIcon,
  FileIcon,
  FileImageIcon,
  FileLinesIcon,
  FilePdfIcon,
  FilePowerpointIcon,
  FileWordIcon
} from "@availity/mui-icon";
function formatBytes(bytes, decimals = 2) {
  if (!+bytes) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}
var FILE_EXT_ICONS = {
  png: FileImageIcon,
  jpg: FileImageIcon,
  jpeg: FileImageIcon,
  gif: FileImageIcon,
  csv: FileCsvIcon,
  ppt: FilePowerpointIcon,
  pptx: FilePowerpointIcon,
  xls: FileExcelIcon,
  xlsx: FileExcelIcon,
  doc: FileWordIcon,
  docx: FileWordIcon,
  txt: FileLinesIcon,
  text: FileLinesIcon,
  zip: FileArchiveIcon,
  "7zip": FileArchiveIcon,
  xml: FileCodeIcon,
  html: FileCodeIcon,
  pdf: FilePdfIcon
};
var isValidKey = (key) => key ? key in FILE_EXT_ICONS : false;
var getFileExtIcon = (fileName) => {
  var _a;
  const ext = ((_a = fileName.split(".").pop()) == null ? void 0 : _a.toLowerCase()) || "";
  const icon = isValidKey(ext) ? FILE_EXT_ICONS[ext] : FileIcon;
  return icon;
};

// src/lib/ErrorAlert.tsx
import { Fragment as Fragment3, jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var codes = {
  "file-too-large": "File exceeds maximum size",
  "file-invalid-type": "File has an invalid type",
  "file-too-small": "File is smaller than minimum size",
  "too-many-file": "Too many files",
  "duplicate-name": "Duplicate file selected"
};
var FILE_SIZE_REGEX = /\b(\d+)\b/;
var formatFileTooLarge = (message) => {
  const fileSize = message.match(FILE_SIZE_REGEX);
  if (!fileSize) return message;
  const formattedSize = formatBytes(Number(fileSize[0]));
  return message.replace(` bytes`, "").replace(FILE_SIZE_REGEX, formattedSize);
};
var ErrorAlert = ({ errors, fileName, id, onClose }) => {
  if (errors.length === 0) return null;
  return /* @__PURE__ */ jsx3(Alert, { severity: "error", onClose, children: errors.length > 1 ? /* @__PURE__ */ jsxs3(Fragment3, { children: [
    /* @__PURE__ */ jsxs3(AlertTitle, { children: [
      "There were ",
      errors.length,
      " error(s) found when uploading ",
      fileName
    ] }),
    /* @__PURE__ */ jsx3(
      List,
      {
        sx: {
          listStyleType: "disc",
          listStylePosition: "inside",
          marginLeft: 1,
          ".MuiListItem-root": {
            display: "list-item"
          }
        },
        disablePadding: true,
        children: /* @__PURE__ */ jsx3(Fragment3, { children: errors.map((error) => {
          const message = error.code === "file-too-large" ? formatFileTooLarge(error.message) : error.message;
          return /* @__PURE__ */ jsx3(ListItem, { disableGutters: true, disablePadding: true, divider: false, children: message }, `${id}-${error.code}`);
        }) })
      }
    )
  ] }) : /* @__PURE__ */ jsxs3(Fragment3, { children: [
    /* @__PURE__ */ jsxs3(AlertTitle, { children: [
      codes[errors[0].code] || "Error",
      ": ",
      fileName
    ] }),
    errors[0].code === "file-too-large" ? formatFileTooLarge(errors[0].message) : errors[0].message
  ] }) });
};

// src/lib/FileList.tsx
import { List as List2, ListItem as ListItem2, ListItemText as ListItemText2, ListItemIcon } from "@availity/mui-list";
import { IconButton as IconButton3 } from "@availity/mui-button";
import { DeleteIcon } from "@availity/mui-icon";
import { Grid as Grid2 } from "@availity/mui-layout";
import { Divider as Divider2 } from "@availity/mui-divider";

// src/lib/UploadProgressBar.tsx
import { useState as useState2 } from "react";
import { Button as Button2, IconButton as IconButton2 } from "@availity/mui-button";

// ../dialog/src/lib/Dialog.tsx
import MuiDialog from "@mui/material/Dialog";
import { styled as styled2 } from "@mui/material/styles";
import { IconButton } from "@availity/mui-button";
import { CloseIcon } from "@availity/mui-icon";
import { jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var CloseButton = (args) => /* @__PURE__ */ jsx4(IconButton, __spreadProps(__spreadValues({ title: "Close Dialog", color: "secondary" }, args), { children: /* @__PURE__ */ jsx4(CloseIcon, { fontSize: "xsmall" }) }));
var CloseButtonSlot = styled2(CloseButton, {
  name: "MuiDialog",
  slot: "AvCloseButton",
  overridesResolver: (props, styles) => styles.avCloseButton
})({
  position: "absolute",
  top: ".5rem",
  right: ".5rem",
  "~ .MuiDialogTitle-root": {
    marginRight: "3.5rem"
  }
});
var Dialog = (_a) => {
  var _b = _a, { children, closeButton = true, onClose } = _b, rest = __objRest(_b, ["children", "closeButton", "onClose"]);
  return /* @__PURE__ */ jsxs4(MuiDialog, __spreadProps(__spreadValues({ onClose }, rest), { children: [
    closeButton ? /* @__PURE__ */ jsx4(CloseButtonSlot, { onClick: onClose }) : null,
    children
  ] }));
};

// ../dialog/src/lib/DialogActions.tsx
import MuiDialogActions from "@mui/material/DialogActions";
import { jsx as jsx5 } from "react/jsx-runtime";
var DialogActions = (_a) => {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx5(MuiDialogActions, __spreadProps(__spreadValues({}, rest), { children }));
};

// ../dialog/src/lib/DialogContent.tsx
import MuiDialogContent from "@mui/material/DialogContent";
import { jsx as jsx6 } from "react/jsx-runtime";
var DialogContent = (_a) => {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx6(MuiDialogContent, __spreadProps(__spreadValues({}, rest), { children }));
};

// ../dialog/src/lib/DialogContentText.tsx
import MuiDialogContentText from "@mui/material/DialogContentText";
import { jsx as jsx7 } from "react/jsx-runtime";

// ../dialog/src/lib/DialogTitle.tsx
import MuiDialogTitle from "@mui/material/DialogTitle";
import { AlertIcons } from "@availity/mui-alert";
import { styled as styled3 } from "@mui/material/styles";
import { jsx as jsx8, jsxs as jsxs5 } from "react/jsx-runtime";
var AlertIcon = styled3("div", {
  name: "MuiDialogTitle",
  slot: "AvIcon",
  overridesResolver: (props, styles) => styles.avIcon
})({
  display: "inline-flex",
  fontSize: "inherit",
  marginRight: ".5rem",
  verticalAlign: "text-bottom"
});
var DialogTitle = (_a) => {
  var _b = _a, { children, component = "h2", icon, variant = "h5" } = _b, rest = __objRest(_b, ["children", "component", "icon", "variant"]);
  return /* @__PURE__ */ jsxs5(MuiDialogTitle, __spreadProps(__spreadValues({ component, variant }, rest), { children: [
    icon ? /* @__PURE__ */ jsx8(AlertIcon, { children: AlertIcons[icon] }) : null,
    children
  ] }));
};

// src/lib/UploadProgressBar.tsx
import { InputAdornment } from "@availity/mui-form-utils";
import { EyeIcon, EyeSlashIcon, WarningTriangleIcon } from "@availity/mui-icon";
import { Box as Box2 } from "@availity/mui-layout";
import { ListItemText } from "@availity/mui-list";
import { LinearProgress } from "@availity/mui-progress";

// ../textfield/src/lib/TextField.tsx
import { forwardRef, useState } from "react";
import MuiTextField from "@mui/material/TextField";
import {
  FormHelperText,
  FormLabel,
  InputPropOverrides,
  SelectAccessibilityOverrides,
  SelectPropOverrides
} from "@availity/mui-form-utils";
import { Grid } from "@availity/mui-layout";
import { Typography as Typography2 } from "@availity/mui-typography";
import { Fragment as Fragment4, jsx as jsx9, jsxs as jsxs6 } from "react/jsx-runtime";
var TextFieldFormHelperText = (_a) => {
  var _b = _a, {
    charCount,
    helperText,
    maxLength,
    showCharacterCount
  } = _b, FormHelperTextProps2 = __objRest(_b, [
    "charCount",
    "helperText",
    "maxLength",
    "showCharacterCount"
  ]);
  if (showCharacterCount) {
    return /* @__PURE__ */ jsxs6(Grid, { container: true, justifyContent: "space-between", flexWrap: "nowrap", children: [
      /* @__PURE__ */ jsx9(FormHelperText, __spreadProps(__spreadValues({}, FormHelperTextProps2), { sx: { marginRight: "12px" }, children: helperText })),
      /* @__PURE__ */ jsxs6(Typography2, { variant: "caption", marginTop: "4px", lineHeight: "1.25rem", children: [
        /* @__PURE__ */ jsx9(Typography2, { component: "span", variant: "inherit", color: charCount > maxLength ? "error" : "textPrimary", children: charCount || 0 }),
        "/",
        maxLength
      ] })
    ] });
  }
  return /* @__PURE__ */ jsx9(FormHelperText, __spreadProps(__spreadValues({}, FormHelperTextProps2), { children: helperText }));
};
var TextField = forwardRef((props, ref) => {
  var _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
  const _a = props, {
    InputProps: InputProps2,
    helpTopicId,
    InputLabelProps,
    FormHelperTextProps: FormHelperTextProps2,
    required,
    SelectProps: SelectProps2,
    inputProps,
    helperText,
    showCharacterCount = false,
    displayOverflowMaxLength = false
  } = _a, rest = __objRest(_a, [
    "InputProps",
    "helpTopicId",
    "InputLabelProps",
    "FormHelperTextProps",
    "required",
    "SelectProps",
    "inputProps",
    "helperText",
    "showCharacterCount",
    "displayOverflowMaxLength"
  ]);
  const [openDetected, setOpenDetected] = useState(false);
  const [charCount, setCharCount] = useState(0);
  const maxLength = (inputProps == null ? void 0 : inputProps.maxLength) || ((_c = (_b = rest.slotProps) == null ? void 0 : _b.htmlInput) == null ? void 0 : _c.maxLength);
  const allReadOnly = (InputProps2 == null ? void 0 : InputProps2.readOnly) || (inputProps == null ? void 0 : inputProps.readOnly) || ((_e = (_d = rest.slotProps) == null ? void 0 : _d.htmlInput) == null ? void 0 : _e.readOnly) || ((_g = (_f = rest.slotProps) == null ? void 0 : _f.input) == null ? void 0 : _g.readOnly);
  const resolvedProps = (props2) => !props2 || Object.keys(props2).length === 0 ? void 0 : props2;
  return /* @__PURE__ */ jsx9(
    MuiTextField,
    __spreadProps(__spreadValues({}, rest), {
      onChange: (event) => {
        setCharCount(event.target.value.length);
        if (rest.onChange) rest.onChange(event);
      },
      helperText: helperText || /* @__PURE__ */ jsx9(Fragment4, {}),
      slots: { formHelperText: TextFieldFormHelperText },
      slotProps: {
        input: resolvedProps(__spreadProps(__spreadValues(__spreadValues(__spreadValues({}, InputProps2), InputPropOverrides), (_h = rest.slotProps) == null ? void 0 : _h.input), {
          readOnly: allReadOnly
        })),
        htmlInput: resolvedProps(__spreadProps(__spreadValues(__spreadValues({
          "aria-required": required
        }, inputProps), (_i = rest.slotProps) == null ? void 0 : _i.htmlInput), {
          maxLength: !displayOverflowMaxLength ? maxLength : void 0
        })),
        select: resolvedProps(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, SelectProps2), SelectPropOverrides), SelectAccessibilityOverrides(openDetected, setOpenDetected, SelectProps2 == null ? void 0 : SelectProps2.open)), (_j = rest.slotProps) == null ? void 0 : _j.select)),
        inputLabel: resolvedProps(__spreadValues(__spreadValues({
          component: FormLabel,
          helpTopicId,
          required,
          shrink: true
        }, InputLabelProps), (_k = rest.slotProps) == null ? void 0 : _k.inputLabel)),
        formHelperText: resolvedProps(__spreadProps(__spreadValues(__spreadValues({
          component: "div"
        }, FormHelperTextProps2), (_l = rest.slotProps) == null ? void 0 : _l.formHelperText), {
          charCount,
          helperText,
          maxLength,
          showCharacterCount
        }))
      },
      ref
    })
  );
});

// src/lib/UploadProgressBar.tsx
import { jsx as jsx10, jsxs as jsxs7 } from "react/jsx-runtime";
var ERROR_MAPPINGS = [
  {
    pattern: /but has an extension for/i,
    friendlyMessage: "File format does not match file extension."
  }
];
var friendlyErrorMessage = (errorMessage) => {
  const mapping = ERROR_MAPPINGS.find(({ pattern }) => pattern.test(errorMessage));
  return mapping ? mapping.friendlyMessage : errorMessage;
};
var UploadProgressBar = ({ upload, onProgress, onError, onSuccess }) => {
  const [statePercentage, setStatePercentage] = useState2(upload.percentage || 0);
  const [errorMessage, setErrorMessage] = useState2(
    upload.errorMessage ? friendlyErrorMessage(upload.errorMessage) : ""
  );
  const [password, setPassword] = useState2("");
  const [showPassword, setShowPassword] = useState2(false);
  const [modalOpen, setModalOpen] = useState2(false);
  const handleOnProgress = () => {
    setStatePercentage(upload.percentage);
    setErrorMessage("");
    if (onProgress) onProgress(upload);
  };
  const handleOnError = () => {
    setErrorMessage(upload.errorMessage ? friendlyErrorMessage(upload.errorMessage) : "Error");
    if (onError) onError(upload);
  };
  const handleOnSuccess = () => {
    setStatePercentage(100);
    setErrorMessage("");
    if (onSuccess) onSuccess(upload);
  };
  const toggleModal = () => {
    setModalOpen((prev) => !prev);
    setPassword("");
  };
  const verifyPassword = (event) => {
    event.preventDefault();
    event.stopPropagation();
    upload.sendPassword(password);
    toggleModal();
  };
  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };
  upload.onProgress.push(handleOnProgress);
  upload.onSuccess.push(handleOnSuccess);
  upload.onError.push(handleOnError);
  return errorMessage ? /* @__PURE__ */ jsxs7(Box2, { sx: { display: "flex", flexWrap: "wrap", columnGap: "4px" }, children: [
    /* @__PURE__ */ jsxs7(
      ListItemText,
      {
        slotProps: { primary: { color: "text.error", variant: "body2", component: "div" } },
        sx: { wordWrap: "break-word" },
        children: [
          /* @__PURE__ */ jsx10(WarningTriangleIcon, { sx: { verticalAlign: "middle", mt: "-2px" } }),
          " ",
          errorMessage
        ]
      }
    ),
    upload.status === "encrypted" && /* @__PURE__ */ jsxs7("div", { className: "pwRequired", children: [
      /* @__PURE__ */ jsx10(Button2, { color: "secondary", size: "small", onClick: toggleModal, children: "Enter Password" }),
      /* @__PURE__ */ jsx10(Dialog, { open: modalOpen, onClose: toggleModal, children: /* @__PURE__ */ jsxs7("form", { onSubmit: verifyPassword, children: [
        /* @__PURE__ */ jsx10(DialogTitle, { children: "Enter Password" }),
        /* @__PURE__ */ jsx10(DialogContent, { children: /* @__PURE__ */ jsx10(
          TextField,
          {
            type: showPassword ? "text" : "password",
            name: "upload-password",
            label: "Password",
            onChange: handlePasswordChange,
            autoFocus: true,
            InputProps: {
              endAdornment: /* @__PURE__ */ jsx10(InputAdornment, { position: "end", children: /* @__PURE__ */ jsx10(
                IconButton2,
                {
                  title: "password visibility",
                  onClick: () => setShowPassword((prev) => !prev),
                  edge: "end",
                  children: showPassword ? /* @__PURE__ */ jsx10(EyeIcon, { fontSize: "small" }) : /* @__PURE__ */ jsx10(EyeSlashIcon, { fontSize: "small" })
                }
              ) })
            }
          }
        ) }),
        /* @__PURE__ */ jsx10(DialogActions, { children: /* @__PURE__ */ jsx10(Button2, { color: "primary", type: "submit", children: "Ok" }) })
      ] }) })
    ] })
  ] }) : /* @__PURE__ */ jsx10(LinearProgress, { value: statePercentage, "aria-label": `${upload.file.name}-progress` });
};

// src/lib/useUploadCore.tsx
import { useQuery } from "@tanstack/react-query";
import Upload from "@availity/upload-core";
function startUpload(file, options) {
  return __async(this, null, function* () {
    const _a = options, { onSuccess, onError, onProgress, onChunkComplete } = _a, uploadOptions = __objRest(_a, ["onSuccess", "onError", "onProgress", "onChunkComplete"]);
    const upload = new Upload(file, uploadOptions);
    yield upload.generateId();
    if (onSuccess) upload.onSuccess.push(onSuccess);
    if (onError) upload.onError.push(onError);
    if (onProgress) upload.onProgress.push(onProgress);
    if (onChunkComplete) upload.onChunkComplete.push(onChunkComplete);
    upload.start();
    return upload;
  });
}
function useUploadCore(file, options, queryOptions) {
  const isQueryEnabled = !!file;
  return useQuery(__spreadValues({
    queryKey: ["upload", file.name, options],
    queryFn: () => startUpload(file, options),
    enabled: isQueryEnabled,
    retry: false,
    refetchOnWindowFocus: false
  }, queryOptions));
}

// src/lib/FileList.tsx
import { jsx as jsx11, jsxs as jsxs8 } from "react/jsx-runtime";
var FileRow = ({
  file,
  options,
  onRemoveFile,
  queryOptions,
  customFileRow: CustomRow,
  disableRemove = false
}) => {
  const Icon = getFileExtIcon(file.name);
  const { data: upload } = useUploadCore(file, options, queryOptions);
  if (!upload) return null;
  if (CustomRow) return /* @__PURE__ */ jsx11(CustomRow, { upload, options, onRemoveFile });
  return /* @__PURE__ */ jsxs8(
    ListItem2,
    {
      disableGutters: true,
      secondaryAction: !disableRemove && /* @__PURE__ */ jsx11(
        IconButton3,
        {
          title: "remove file",
          edge: "end",
          onClick: () => {
            onRemoveFile(upload.id, upload);
          },
          children: /* @__PURE__ */ jsx11(DeleteIcon, {})
        }
      ),
      children: [
        /* @__PURE__ */ jsxs8(Grid2, { container: true, spacing: 2, alignItems: "center", justifyContent: "space-between", width: "100%", flexWrap: "wrap", children: [
          /* @__PURE__ */ jsx11(Grid2, { size: { xs: "auto" }, children: /* @__PURE__ */ jsx11(ListItemIcon, { sx: { minWidth: "1.5rem" }, children: /* @__PURE__ */ jsx11(Icon, {}) }) }),
          /* @__PURE__ */ jsx11(Grid2, { size: { xs: 4 }, sx: { minWidth: "8rem" }, children: /* @__PURE__ */ jsx11(ListItemText2, { sx: { wordBreak: "break-all" }, children: upload.trimFileName(upload.file.name) }) }),
          /* @__PURE__ */ jsx11(Grid2, { size: { xs: 2 }, sx: { minWidth: "3rem" }, children: /* @__PURE__ */ jsx11(ListItemText2, { sx: { textAlign: "end" }, children: formatBytes(upload.file.size) }) }),
          /* @__PURE__ */ jsx11(Grid2, { size: { xs: "grow" }, sx: { minWidth: "6rem" }, children: /* @__PURE__ */ jsx11(UploadProgressBar, { upload }) })
        ] }),
        /* @__PURE__ */ jsx11(Divider2, {})
      ]
    }
  );
};
var FileList = ({
  files,
  options,
  onRemoveFile,
  queryOptions,
  customFileRow,
  disableRemove
}) => {
  if (files.length === 0) return null;
  return /* @__PURE__ */ jsx11(List2, { children: files.map((file) => {
    return /* @__PURE__ */ jsx11(
      FileRow,
      {
        file,
        options,
        onRemoveFile,
        queryOptions,
        customFileRow,
        disableRemove
      },
      file.name
    );
  }) });
};

// src/lib/FileSelector.tsx
import { useState as useState3 } from "react";
import { useFormContext as useFormContext2 } from "react-hook-form";
import { useQueryClient } from "@tanstack/react-query";
import { Grid as Grid3 } from "@availity/mui-layout";
import { Typography as Typography5 } from "@availity/mui-typography";
import { Alert as Alert2, AlertTitle as AlertTitle2 } from "@availity/mui-alert";

// src/lib/FileTypesMessage.tsx
import { Typography as Typography3 } from "@availity/mui-typography";
import { jsxs as jsxs9 } from "react/jsx-runtime";
var FileTypesMessage = ({
  allowedFileTypes = [],
  customSizeMessage,
  customTypesMessage,
  maxFileSize,
  variant = "caption"
}) => {
  const fileSizeMsg = customSizeMessage || (typeof maxFileSize === "number" ? `Maximum file size is ${formatBytes(maxFileSize)}. ` : null);
  const fileTypesMsg = customTypesMessage || (allowedFileTypes.length > 0 ? `Supported file types include: ${allowedFileTypes.join(", ")}` : "All file types allowed.");
  return /* @__PURE__ */ jsxs9(Typography3, { variant, children: [
    fileSizeMsg,
    fileTypesMsg
  ] });
};

// src/lib/HeaderMessage.tsx
import { Typography as Typography4 } from "@availity/mui-typography";
import { jsxs as jsxs10 } from "react/jsx-runtime";
var HeaderMessage = ({ maxFiles, maxSize }) => {
  return /* @__PURE__ */ jsxs10(Typography4, { variant: "h6", children: [
    "Attach up to ",
    maxFiles,
    " file(s), with a maximum individual size of ",
    formatBytes(maxSize)
  ] });
};

// src/lib/FileSelector.tsx
import { Fragment as Fragment5, jsx as jsx12, jsxs as jsxs11 } from "react/jsx-runtime";
var CLOUD_URL = "/cloud/web/appl/vault/upload/v1/resumable";
var FileSelector = ({
  name,
  allowedFileNameCharacters,
  allowedFileTypes = [],
  bucketId,
  clientId,
  children,
  customSizeMessage,
  customTypesMessage,
  customerId,
  customFileRow,
  disabled = false,
  enableDropArea = true,
  endpoint,
  isCloud,
  label = "Upload file",
  maxFiles,
  maxSize,
  multiple = true,
  onChange,
  onDrop,
  onUploadRemove,
  queryOptions,
  uploadOptions,
  validator,
  disableRemove
}) => {
  const [totalSize, setTotalSize] = useState3(0);
  const [fileRejections, setFileRejections] = useState3([]);
  const client = useQueryClient();
  const formMethods = useFormContext2();
  const options = __spreadProps(__spreadValues({}, uploadOptions), {
    bucketId,
    customerId,
    clientId,
    fileTypes: allowedFileTypes,
    maxSize,
    allowedFileNameCharacters
  });
  if (endpoint) options.endpoint = endpoint;
  if (isCloud) options.endpoint = CLOUD_URL;
  const handleOnRemoveFile = (uploadId, upload) => {
    const prevFiles = formMethods.getValues(name);
    const newFiles = prevFiles.filter((file) => file.name !== upload.file.name);
    if (newFiles.length !== prevFiles.length) {
      const removedFile = prevFiles.find((file) => file.name === upload.file.name);
      try {
        upload.abort();
      } catch (e) {
        console.error("Encountered an issue stopping the file upload");
      }
      formMethods.setValue(name, newFiles);
      client.removeQueries(["upload", upload.file.name]);
      if (removedFile == null ? void 0 : removedFile.size) setTotalSize(totalSize - removedFile.size);
      if (onUploadRemove) onUploadRemove(newFiles, uploadId);
    }
  };
  const files = formMethods.watch(name);
  const handleRemoveRejection = (id) => {
    const rejections = fileRejections.filter((value) => value.id !== id);
    setFileRejections(rejections);
  };
  const TOO_MANY_FILES_CODE = "too-many-files";
  const tooManyFilesRejections = fileRejections.filter(
    (rejection) => rejection.errors.some((error) => error.code === TOO_MANY_FILES_CODE)
  );
  const otherRejections = fileRejections.filter(
    (rejection) => !rejection.errors.some((error) => error.code === TOO_MANY_FILES_CODE)
  );
  return /* @__PURE__ */ jsxs11(Fragment5, { children: [
    enableDropArea ? /* @__PURE__ */ jsxs11(Fragment5, { children: [
      label ? /* @__PURE__ */ jsx12(Typography5, { marginBottom: "4px", children: label }) : null,
      /* @__PURE__ */ jsx12(
        Dropzone,
        {
          name,
          allowedFileTypes,
          disabled,
          enableDropArea,
          maxFiles,
          maxSize,
          multiple,
          onChange,
          onDrop,
          setFileRejections,
          setTotalSize,
          validator
        }
      ),
      /* @__PURE__ */ jsx12(
        FileTypesMessage,
        {
          allowedFileTypes,
          maxFileSize: maxSize,
          customSizeMessage,
          customTypesMessage,
          variant: "caption"
        }
      ),
      children
    ] }) : /* @__PURE__ */ jsxs11(Grid3, { container: true, rowSpacing: 3, flexDirection: "column", children: [
      /* @__PURE__ */ jsxs11(Grid3, { children: [
        /* @__PURE__ */ jsx12(HeaderMessage, { maxFiles, maxSize }),
        /* @__PURE__ */ jsx12(
          FileTypesMessage,
          {
            allowedFileTypes,
            customSizeMessage,
            customTypesMessage,
            variant: "body2"
          }
        )
      ] }),
      children ? /* @__PURE__ */ jsx12(Grid3, { children }) : null,
      /* @__PURE__ */ jsx12(Grid3, { children: /* @__PURE__ */ jsx12(
        Dropzone,
        {
          name,
          allowedFileTypes,
          disabled,
          enableDropArea,
          maxFiles,
          maxSize,
          multiple,
          onChange,
          onDrop,
          setFileRejections,
          setTotalSize,
          validator
        }
      ) })
    ] }),
    tooManyFilesRejections.length > 0 && /* @__PURE__ */ jsxs11(
      Alert2,
      {
        severity: "error",
        onClose: () => tooManyFilesRejections.forEach((rejection) => handleRemoveRejection(rejection.id)),
        children: [
          /* @__PURE__ */ jsx12(AlertTitle2, { children: "Items not allowed." }),
          "Too many files are selected for upload, maximum ",
          maxFiles,
          " allowed."
        ]
      }
    ),
    otherRejections.length > 0 && otherRejections.map((rejection) => /* @__PURE__ */ jsx12(
      ErrorAlert,
      {
        errors: rejection.errors,
        fileName: rejection.file.name,
        id: rejection.id,
        onClose: () => handleRemoveRejection(rejection.id)
      },
      rejection.id
    )),
    /* @__PURE__ */ jsx12(
      FileList,
      {
        files: files || [],
        options,
        onRemoveFile: handleOnRemoveFile,
        queryOptions,
        customFileRow,
        disableRemove
      }
    )
  ] });
};
export {
  Dropzone,
  ErrorAlert,
  FileList,
  FilePickerBtn,
  FileRow,
  FileSelector,
  FileTypesMessage,
  HeaderMessage,
  UploadProgressBar,
  formatFileTooLarge,
  useUploadCore
};
